module.exports = __webpack_public_path__ + "static/media/Shabnam-Light.acc9a0c4.woff2";